import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type activationOrderTechnicalInfoType = {
  id: string;
  errorCallback: Function;
  resultKey?: string;
  successCallback?: Function;
};

export default ({
  id,
  errorCallback,
  resultKey = 'activationOrderTechnicalInfoData',
  successCallback,
}: activationOrderTechnicalInfoType) =>
  requestAsync({
    url: endpoints.getActivationOrderTechnicalInfoUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getActivationOrderTechnicalInfoUrl(id),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
